import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { widgetItem } from 'modules/maya/basics/styles/widget.style';
import useCountTargetsWidget from 'modules/maya/components/CountWidgets/CountTargetsWidget/CountTargetsWidget.hook';
import { CountWidgetPropsType } from 'modules/maya/components/CountWidgets/CountWidget.types';
import Loader from 'yoda-ui/Loader';
import { YodaColors } from 'yoda-ui/yodaTheme';

const CountTargetsWidget: FC<CountWidgetPropsType> = ({
  filters,
}) => {
  const { value, loading } = useCountTargetsWidget(filters);
  const { t } = useTranslation();

  return (
    <Box sx={ widgetItem } >
      <Box color={ YodaColors.primaryBlue } >{ t('maya_count_targets_widget_label') }</Box>
      <Box visibility={ loading ? 'hidden' : 'inherit' } >{ value !== undefined ? value as number : '-' }</Box>
      { loading ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : null }
    </Box>
  );
};

export default CountTargetsWidget;
